<template>
  <div class="home">
  	<div class="profile" v-if="user.account">
  		<h2>{{$t("home.AccountInformation")}}</h2>
  		<div>
  			<span><i>{{$t("home.UserName")}}</i><em>{{user.account}}</em></span>
  			<span><i>{{$t("home.Nickname")}}</i>
			  <em v-if="!isEdit">{{user.nick || $t("home.Notset")}} <img src="../assets/edit.png" class="nick-btn" @click="editNick()"/></em>
			  <div v-else class="edit-box">
				<input type="text" v-model="nick" ref="editInput" :placeholder='$t("home.Nickname")' @blur="blurNick" class="edit-input"/> 
				<img src="../assets/complete.png" class="nick-btn" @click="subNick"/>
			  </div>
			</span>
  		</div>
  		<div>
  			<span><i>{{$t("home.TheLatestLoginDate")}}</i><em>{{user.last_login_time || '-'}}</em></span>
  			<span><i>IP</i><em>{{user.last_login_ip || '-'}}</em></span>
  		</div>
  		<div>
  			<span><i>{{$t("home.SecurityLevel")}}</i><b><img src="../assets/star.png" alt="" v-for="(itm,idx) in safeLevel" :key="'star-'+idx"></b></span>
			<span><i>LOC</i><em>{{user.loc || '-'}}</em></span>
  		</div>
  	</div>
  	<div class="security">
  		<b>{{$t("home.SecurityTip")}}</b>
  		<ul>
  			<li>
  				<span><img src="../assets/home-security-1.png" alt=""></span>
  				<div>
  					<b>{{$t("home.PasswordLevel")}}</b>
  					<i>{{$t("home.Security")}}:{{user.password_level>2?$t('home.SecurityHigh'):$t('home.SecurityLow')}}</i>
  					<em>{{user.password_level>2?$t("home.PasswordLevelHigh"):$t("home.PasswordLevelLow")}}</em>
  				</div>
  				<wd-button  :bordered="true" :styles="btnStyles" to="password">{{$t("home.Change")}}</wd-button>
  			</li>
  			<li v-if="base_configs.used_realname">
  				<span><img src="../assets/home-security-2.png" alt=""></span>
  				<div>
  					<b>{{$t("home.PersonalInformation")}}</b>
  					<i>{{user.has_card_id?$t("home.Submitted"):$t('home.Unsubmitted')}}</i>
  					<em>{{$t('home.RealNameTip')}}</em>
  				</div>
  				<wd-button  :bordered="true" :styles="btnStyles" to="authentication">{{user.has_card_id?$t("home.Change"):$t("home.Bind")}}</wd-button>
  			</li>
  			<li v-if="base_configs.used_phone_reg">
  				<span><img src="../assets/home-security-3.png" alt=""></span>
  				<div>
  					<b>{{$t("home.MobilePhonebinding")}}</b>
  					<i>{{user.phone?$t("home.Bound"):$t('home.Unbound')}}</i>
  					<em>{{$t('home.SecurityQuestionTip')}}</em>
  				</div>
  				<wd-button  :bordered="true" :styles="btnStyles" to="phone">{{user.phone?$t("home.Change"):$t("home.Bind")}}</wd-button>
  			</li>
  			<li>
  				<span><img src="../assets/home-security-4.png" alt=""></span>
  				<div>
  					<b>{{$t("home.Emailbinding")}}</b>
  					<i>{{user.email?$t("home.Bound"):$t('home.Unbound')}}</i>
  					<em>{{$t('home.SecurityQuestionTip')}}</em>
  				</div>
  				<wd-button  :bordered="true" :styles="btnStyles" to="email">{{user.email?$t("home.Change"):$t("home.Bind")}}</wd-button>
  			</li>
  			<li>
  				<span><img src="../assets/home-security-5.png" alt=""></span>
  				<div>
  					<b>{{$t("home.SecurityQuestion")}}</b>
  					<i>{{user.has_security_questions?$t("home.Set"):$t('home.Notset')}}</i>
  					<em>{{$t('home.SecurityQuestionTip')}}</em>
  				</div>
  				<wd-button  :bordered="true" :styles="btnStyles" to="question">{{user.has_security_questions?$t("home.Change"):$t("home.Setting")}}</wd-button>
  			</li>
  		</ul>
  	</div>
  </div>
</template>

<script>
import WdButton from "@/components/WdButton.vue";
export default {
  name: 'home',
  components:{
  	'wd-button':WdButton
  },
  data(){
  	return {
  		user:{
  			id:0,
  			account:"",
  			nick:"",
  			last_login_time:"",
  			last_login_ip:"",
  			phone:"",
  			email:"",
  			has_security_questions:false,
  			has_card_id:false,
  			password_level:1
		  },
		isEdit:false,
		nick:'',
  		btnStyles:{
  			width:'100px',
  			marginTop:'20px',
  			float:'right'
		  },
		base_configs:{}
  	}
  },
  computed:{
    safeLevel(){
      let level = 0;
      if(this.user.phone) level+=1;
      if(this.user.email) level+=1;
      if(this.user.has_card_id) level+=1;
      if(this.user.password_level>2) level+=1;
      if(this.user.has_security_questions) level+=1;
      return level;
    }
  },
  
  async created(){
	this.from = this.$route.query.from || '';
	let {base_configs} = await this.$getAppBaseData(this.from);
	this.base_configs = base_configs

	let user = await this.$getUser();
    if(user){
      this.user = user;
      this.user.has_card_id = !!user.anti_level;
      this.user.has_security_questions = !!user.security_question;
	}
  },
  methods:{
	  editNick(name){
		  this.isEdit = true;
		  this.nick = this.user.nick;
		  this.$nextTick(function() {
            this.$refs.editInput.focus();
        })	
	  },
	  async subNick(){
		  	if(!this.nick){
				this.$alert(this.$t('home.NicknameTip'));
				return;
			}
			let response = await this.$api.post('/web/index/modifyUser',{nick:this.nick});
			if(response.code == 0){
				this.$alert(this.$t('home.NicknameSet'));
				this.isEdit = false;
				this.user.nick = this.nick;
				this.nick = '';
			}else{
				this.$alert(response.msg)
			}	  
	  },
	  blurNick(){
		if(this.nick == this.user.nick){
			this.nick = '';
		  	this.isEdit  = false;
		}	  
	  }
  }
}
</script>
<style scoped="">
.home{
	width: 700px;
	margin: 20px auto
}
.profile{
	margin-bottom: 20px;
}
.profile h2{
	font-size: 16px;
}
.profile span{
	display: inline-block;
	width: 50%;
	font-size: 14px
}
.profile div{
	margin-bottom: 10px;
}
.profile span i{
	display: inline-block;
	width: 160px;
	text-align: right;
	color: #202020;
	padding-right: 10px;
}
.profile span em{
	display: inline-block;
	border: 1px solid #d5d5d5;
	border-radius: 2px;
	width: 160px;
	padding: 7px;
	position: relative;
}
.profile span img{
	width: 14px;
}
.security{
	margin-top: 40px;
}
.security ul{
	margin-top: 20px;
}
.security li{
	background-color: #f6f6f6;
	border-radius: 5px;
	padding: 10px 20px;
	margin-bottom: 10px;
	height: 80px;
}
.security li span{
	float: left;
	border: 1px solid #818599;
	width: 80px;
	height: 80px;
	padding: 3px;
	border-radius: 50%;
	box-sizing: border-box;
}
.security li span img{
	background-color: #818599;
	width: 100%;
	height: 100%;
	border-radius: 50%;
	padding: 20px;
	box-sizing: border-box;
}
.security li div{
	float: left;
	margin-left: 15px;
	width: 430px;
	height: 80px;
	display: flex;
	flex-direction: column;
	justify-content:center;
}
.security li div b{
	display: block;
	font-size: 16px;
}
.security li div i{
	display: block;
	font-size: 12px;
	line-height: 22px;
	color: #2d2d2d
}
.security li div em{
	display: block;
	font-size: 12px;
	color: #2d2d2d;
}
.profile .nick-btn{
	position:absolute;
	top: 6px;
	right: 5px;
	width: 20px;
	height: 20px;
	cursor: pointer;
}
.profile .edit-box{
	border: 1px solid #d5d5d5;
	padding: 0px 10px;
	box-sizing: border-box;
	-webkit-box-sizing: border-box;
	position: relative;
	width: 175px;
	display: inline-block;
	margin-bottom: 0;
}
.profile .edit-box input{
	border: none;
	width: 120px;
	height: 28px;
}
.profile .edit-box input:focus{outline:none;}
</style>
